import { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface Props {
  placeholder: string;
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  value?: any;
  name?: string;
  required: boolean;
  helperText: string;
  disabled?: boolean;
  data: any;
  onRoleSelect: (id: string) => void;
}

interface StyledInputProps {
  helperText: string;
}

const DropdownCheckbox = ({
  onChange,
  placeholder,
  label,
  value,
  name,
  required,
  helperText,
  disabled,
  data,
  onRoleSelect,
}: Props) => {
  const [dropdown, setShowDropdown] = useState(false);

  const getLabel = (value: any, data: any) => {
    let filteredLabel = [];
    let filtered = data.filter(function (e: any) {
      // @ts-ignore
      return this.indexOf(e.value) >= 0;
    }, value);
    filteredLabel = filtered.map((role: any) => role.label);
    return filteredLabel.join(",");
  };

  const useOutsideAlerter = (ref: any) => {
    useEffect(() => {
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowDropdown(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  };
  const wrapperRef = useRef(null);

  useOutsideAlerter(wrapperRef);

  const checkAvailability = (id: any, selectedRoles: any) => {
    if (
      (id === 3 || id === 4) &&
      (selectedRoles.includes(2) || selectedRoles.includes(1))
    ) {
      return false;
    }
    if (
      (id === 1 || id === 2) &&
      (selectedRoles.includes(3) || selectedRoles.includes(4))
    ) {
      return false;
    }
    return true;
  };

  const handleRoleSelect = (id: any, selectedRoles: any) => {
    if (
      (id === 3 || id === 4) &&
      (selectedRoles.includes(2) || selectedRoles.includes(1))
    ) {
      return false;
    }
    if (
      (id === 1 || id === 2) &&
      (selectedRoles.includes(3) || selectedRoles.includes(4))
    ) {
      return false;
    }
    onRoleSelect(id);
  };

  return (
    <>
      <InputFieldWrapper ref={wrapperRef}>
        {label && (
          <Label>
            {label}
            {required && <span>*</span>}
          </Label>
        )}
        <InputField
          disabled={disabled}
          placeholder={placeholder}
          value={getLabel(value, data)}
          name={name}
          helperText={helperText}
          autoComplete="off"
          onClick={() => setShowDropdown(true)}
        />
        {helperText && <Error>{helperText}</Error>}
        {dropdown && (
          <DropdownList>
            <ul>
              <li>
                <span>{"Select Role"}</span>
              </li>
              {data.map((role: any) => (
                <li>
                  {role.value && (
                    <>
                      <button
                        onClick={() => handleRoleSelect(role.value, value)}
                      >
                        {!value.includes(role.value) ? (
                          <img
                            style={{
                              opacity: checkAvailability(role.value, value)
                                ? 1
                                : 0.5,
                            }}
                            src={require("../../assets/images/non-checked.png")}
                            alt="fill"
                          />
                        ) : (
                          <img
                            src={require("../../assets/images/checked.png")}
                            alt="fill"
                          />
                        )}
                      </button>
                    </>
                  )}
                  <span>{role.label}</span>
                </li>
              ))}
            </ul>
          </DropdownList>
        )}
      </InputFieldWrapper>
    </>
  );
};

const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

const DropdownList = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 3.9rem;
  width: 99.5%;
  background: white;
  border: 1px solid ${Colors.athensGrey};
  border-bottom-left-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
  > ul {
    padding: 0;
    margin: 0.5rem 0;
    list-style-type: none;
    padding-left: 1rem;
    li {
      padding: 0.25rem 0;
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      button {
        margin-right: 0.5rem;
        padding: 0;
        border: 0;
        background: transparent;
      }
    }
  }
`;

const InputField = styled.input<StyledInputProps>`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 12px;
  padding: 0.75rem 0.5rem;
  border-radius: 0.25rem;
  border: 1px solid
    ${(props) => (props.helperText ? Colors.red : Colors.athensGrey)};
  ::placeholder {
    color: ${Colors.autumnFog};
  }
  :focus {
    outline: none;
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor: no-drop;
  }
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 13px;
  line-height: 16px;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
  > span {
    color: ${Colors.red};
    margin-left: 2px;
  }
`;

const Error = styled.span`
  color: ${Colors.red};
  font-size: 0.75rem;
  margin-top: 0.25rem;
`;

export default DropdownCheckbox;
